import { render, staticRenderFns } from "./ProdutosPesquisaMercado.vue?vue&type=template&id=c9ad1eae&scoped=true"
import script from "./ProdutosPesquisaMercado.vue?vue&type=script&lang=js"
export * from "./ProdutosPesquisaMercado.vue?vue&type=script&lang=js"
import style0 from "./ProdutosPesquisaMercado.vue?vue&type=style&index=0&id=c9ad1eae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9ad1eae",
  null
  
)

export default component.exports